module.exports = __webpack_public_path__ + "static/media/suggestion-box-icon-otheractions.60a73b57.svg";